import type { IUserProfileClaim } from "@gik/calendar/models/Claim";
import type { SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { useApi } from "@gik/core/api/swr/useApi";

const path = "claims";

function getParams(userId: string, period: "upcoming" | "history") {
	return {
		userId,
		period,
		perPage: 999,
	};
}

export function useUpcomingClaims(
	userId?: string,
	config?: SWRConfigInterface,
) {
	return useApi<IUserProfileClaim[]>(
		userId ? `${path}` : null,
		getParams(userId, "upcoming"),
		config,
	);
}

export function useHistoryClaims(userId?: string, config?: SWRConfigInterface) {
	return useApi<IUserProfileClaim[]>(
		userId ? `${path}` : null,
		getParams(userId, "history"),
		config,
	);
}
